import { PlusCircle } from "@phosphor-icons/react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import useAppStore from "common/hooks/useAppStore";

import LeadsImage from "assets/images/empty-placeholders/leads.png";

export default function CreateCampaign() {
  const setIsCampaignModalOpen = useAppStore(
    (state) => state.setIsCampaignModalOpen,
  );

  return (
    <EmptyPlaceholder
      imageSrc={LeadsImage}
      title="No leads yet"
      subtitle="It looks like you do not have any LinkedIn connections - create a campaign to start your outreach"
      actionComponent={
        <RestrictedComponent visibleFor={["campaigns_full"]}>
          <Button
            onClick={() => setIsCampaignModalOpen(true)}
            leftIcon={<PlusCircle weight="fill" />}
          >
            Create campaign
          </Button>
        </RestrictedComponent>
      }
    />
  );
}
